import { oneOf } from 'prop-types';
import React from 'react';

import iconDefault from '../../assets/favicon.ico';
import iconModified from '../../assets/favicon-modified.ico';

const icons = {
  default: iconDefault,
  modified: iconModified,
};

class Favicon extends React.Component {
  componentDidMount() {
    this.injectIcon();
    this.updateIcon();
  }

  componentDidUpdate({ status: prevStatus }) {
    if (this.props.status !== prevStatus) this.updateIcon();
  }

  componentWillUnmount() {
    this.removeIcon();
  }

  injectIcon() {
    const node = document.createElement('link');
    node.rel = 'shortcut icon';
    this.node = node;
    document.head.appendChild(node);
  }

  removeIcon() {
    this.node.remove();
    this.node = null;
  }

  updateIcon() {
    this.node.href = icons[this.props.status];
  }

  render() {
    return null;
  }
}

Favicon.propTypes = {
  status: oneOf(['default', 'modified']).isRequired,
};

export default Favicon;
